import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    Pager
} from 'devextreme-react/data-grid';
import Request from "../../components/Request/Request";
import CustomStore from 'devextreme/data/custom_store';  
import './AsgariUcretTanim.scss'; 
import { Button, Popup } from 'devextreme-react';
import AsgariUcretTanimDetay from './AsgariUcretTanimDetay';
import * as AppActions from '../../actions/AppActions';
import { custom } from 'devextreme/ui/dialog';


const AsgariUcretTanim = () => {

    const dispatch = useDispatch();

    const listeBasligi = "Asgari Ücret Tanım";
    const [store, setStore] = useState(null); 
    const [detayData, setDetayData] = useState({ popupState: false, data: [] });
   
    let dataGrid = null;

    useEffect(() => {
        yenile();
    }, []);

    const getStore = () => {
        return new CustomStore({
            key: 'id',
            load: function () {
                const request = new Request("/emeklilik-app/api/asgari-ucret-tanim/getList", "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    const yenile = () => {
        setStore(getStore());
    }
    function hideDetayDataPopup() {
        setDetayData({ popupState: false, data: {} })
        yenile();
    }
    function editDetay(data) {
        setDetayData({ popupState: true, data: data })
    }
    function copyDetay(data) {
        let d = data;
        d.id=null;
        setDetayData({ popupState: true, data: d })
    }
    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: () => { return true },
            options: {
                icon: 'add',
                onClick: () => {
                    setDetayData({ popupState: true, data: null })
                }
            }
        });
    }
    function deleteDetay(data) {
        let myDialog = custom({
            title: "Silme Uyarı",
            messageHtml: "<b>Seçili kaydı silmek istiyor musunuz?</b>",
            buttons: [{
                text: "Evet",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            }, {
                text: "Hayır",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            },
            ]
        });
        myDialog.show().then((dialogResult) => {
            if (dialogResult.buttonText === 'Evet') {
                dispatch(AppActions.setLoading(true, "Kayıtlar siliniyor.."));
                const request = new Request("/emeklilik-app/api/asgari-ucret-tanim/delete/" + data.id, "DELETE");
                request.run()
                    .then(response => {
                        dispatch(AppActions.setLoading(false, ""));
                        if (response.statusText == 'OK') {
                            yenile();
                        }
                    });
            }

        });
 
    }
    
    return (
        <div>
            <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    {/* <Button icon="plus" width={150} text="Yeni Kayıt" type={'success'} style={{ fontSize: "15px" }}></Button> */}
                </div>
            </div>

            <DataGrid
                className="asgariUcretGrid"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                onToolbarPreparing={onToolbarPreparingDetay}
            //selection={{ mode: 'single', deferred: true }} 
            >
                <FilterRow visible={true} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging defaultPageSize={100} />
                <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        {
                            hint: 'Copy', icon: 'copy', 
                            onClick: (e) => { copyDetay(e.row.data); }
                        },
                        {
                            hint: 'Düzenle', icon: 'edit', 
                            onClick: (e) => { editDetay(e.row.data); }
                        },
                        {
                            hint: 'Sil', icon: 'remove', 
                            onClick: (e) => { deleteDetay(e.row.data); }
                        } 
                    ]}
                />

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'baslangicTarihi'} width={150} caption={'Başlangıç Tarihi'} dataType="date" format="yyyy-MM-dd" visible={true}   defaultSortOrder="desc"/>
                <Column dataField={'bitisTarihi'} width={150} caption={'Bitiş Tarihi'} dataType="date"  format="yyyy-MM-dd" visible={true} />
                <Column dataField={'asgariUcretTutari'} width={150} caption={'Tutar'} dataType="number" format={"#,##0.00"}  visible={true} />
                <Column dataField={'asgariUcretGunlukTutari'} width={150} caption={'Günlük Tutar'} dataType="number" format={"#,##0.00"} visible={true} />
                <Column dataField={'asgariUcretMaxTutari'} width={150} caption={'Max Tutar'} dataType="number" format={"#,##0.00"}  visible={true} />
                <Column dataField={'asgariUcretMaxOran'} width={150} caption={'Max Oran'} dataType="number" format={"#,##0.00"}  visible={true} />
                <Column dataField={'bosColumn'} width={150} caption={''} dataType="string" visible={true} />
            </DataGrid>
 
            <Popup
                visible={detayData.popupState}
                onHiding={hideDetayDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Kullanıcı Detay Bilgi"
                width={350}
                height={360}
            >
                <div>
                    {detayData.popupState ? <AsgariUcretTanimDetay data={detayData.data} hide={hideDetayDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideDetayDataPopup}
                    />
                </div>
            </Popup>

        </div>
    );


}

export default AsgariUcretTanim;
